export class SupplierBranchData {
  Supplier: number = 0;
  Branches: number[] = [];
}
